import { THEME } from './lib/env';
import { StylesProvider, keyframes, useStyles } from './lib/hooks/useStyles';
import * as linkpickTheme from './lib/themes/linkpick';
import { Autocomplete2 } from './lib/components/Autocomplete';
import { TextField } from './lib/components/Textfield';
import { PhoneInput } from './lib/components/PhoneInput';
import { AuthGoogleLinkedin } from './lib/components/AuthGoogleLinkedin';
import Checkbox from './lib/components/Checkbox';
import { combine } from './lib/utils/styles';
import { Tooltip } from './lib/components/Tooltip';
import Select from './lib/components/Select';
import InfoTooltip from './lib/components/Tooltip';

const switchThemeComponent = (themeComponent) =>
  themeComponent?.[THEME] || themeComponent?.default;

export {
  linkpickTheme,
  switchThemeComponent,
  useStyles,
  StylesProvider,
  keyframes,
  Autocomplete2,
  TextField,
  PhoneInput,
  AuthGoogleLinkedin,
  Checkbox,
  combine,
  Tooltip,
  Select,
  InfoTooltip,
};
